import { put, select, call } from 'redux-saga/effects'
import * as actions from '../../redux/action_creators'
import * as api from '../../api/api'
import * as client from '../../api/client'
import { getProfileId, getBootstrapped } from '../selectors'
import { getTeamMembers } from '../sagas/team_sagas'
import { makeToast } from '../../util/toast_util'
import { handleGetProfile } from './profile_sagas'
import { sitka } from "../store"

export function* handleSocketStatus({ status }) {
    switch (status) {
        case 'connect': {
            const bootstrapped = yield select(getBootstrapped)
            if (bootstrapped) return
            yield put(actions.startBootstrap())
            break
        }
        case 'disconnect':
            yield put(actions.setBootstrapped(false))
            break
        case 'reconnect':
            yield put(actions.startBootstrap())
            yield put(actions.fetchCurrentHorizon())
            break
    }
}

export function* handleSocketEvent({ event, object }) {
    if ( !event || !object ) {
        // ignore malformed messages
        return
    }

    if ( event.requestId && event.requestId.indexOf(api.requestIDPrefix) === 0 ) {
        // ignore socket events that originate from a local request
        return
    }

    const { id, attributes, type } = object.data
    const record = { id, ...attributes }

    switch(type) {
        case 'timerecords': {
            switch( event.action ) {
                case 'create':
                case 'update': {
                    yield put(actions.receiveTimeEntry(record))
                    const profileId = yield select(getProfileId)
                    if (profileId === record.userId) {
                        yield put( actions.addRecentTagCombo({id: record.id, tags: record.tags}) )
                    }
                    break
                }
                case 'delete': {
                    yield put(actions.removeTimeEntry(record))
                    break
                }
            }
            break
        }

        case 'tags': {
            switch( event.action ) {
                case 'create':
                case 'update': {
                    yield put(actions.receiveTags(record))
                    break
                }
                case 'delete': {
                    yield put(actions.removeTag(record))
                    break
                }
                default:
            }
            break
        }

        case 'teams': {
            switch( event.action ) {
                case 'create':
                case 'update': {
                    yield put(actions.receiveTeam(record))
                    break
                }
                case 'delete': {
                    // not yet supported
                    break
                }
                default:
            }
            break
        }

        case 'members': {
            switch( event.action ) {
                case 'create':
                case 'update': {
                    yield call(getTeamMembers, { teamId: record.teamId })
                    yield call(handleGetProfile)
                    break
                }
                case 'delete':
                case 'disable': {
                    yield call(getTeamMembers, { teamId: record.teamId })
                    try {
                        const resp = yield call(client.getProfile)
                        const { teams } = resp
                        yield put(actions.receiveTeams(teams))
                    } catch (e) {
                        console.log('Error fetching profile: ', e) // eslint-disable-line no-console
                    }
                    break
                }
                default:
            }
            break
        }

        case 'teamInvites': {
            switch( event.action ) {
                case 'create': {
                    yield call(getTeamMembers, { teamId: record.teamId })
                    const msg = "A member has been invited."
                    const ind = "success"
                    yield call(makeToast, msg, ind)
                    break
                }
                case 'update': {
                    yield call(getTeamMembers, { teamId: record.teamId })
                    break
                }
                case 'delete': {
                    yield call(getTeamMembers, { teamId: record.teamId })

                    // This code is disabled because "Invite removed" was being shown
                    // to a team admin when a new team user accepted an invite.

                    // const msg = "Invite removed."
                    // const ind = "success"
                    // yield call(makeToast, msg, ind)
                    break
                }
                default:
            }
            break
        }

        case 'goals': {
            switch( event.action ) {
                case 'create':
                case 'update': {
                    yield put(actions.fetchGoal(record.id))
                    break
                }
                case 'delete': {
                    yield put(actions.removeGoal(record))
                    break
                }
                default:
            }
            break
        }

        case 'customer': {
            switch(event.action) {
                case 'create':
                case 'update': {
                    // get ownerId string from nested record object
                    yield put(actions.handleWebsocketCustomerUpdated(record.ownerId))
                    break
                }
                default:
            }
            break
        }

        case 'accounts': {
            switch(event.action) {
                case 'create':
                case 'update': {
                    // get ownerId string from nested record object
                    yield put(actions.handleWebsocketAccountsUpdated(record.ownerId))
                    break
                }
                default:
            }
            break
        }

        case 'oauthtokensummary': {
            switch(event.action) {
                case 'create': {
                    yield call(sitka.getModules().oauth.handleNewOAuthTokenSummary, record)
                    break
                }
                // todo: handle delete/update
                default:
            }
            break
        }

        case 'googleCalendarConfig': {
            switch(event.action) {
                case 'create': {
                    yield call(sitka.getModules().googleCalendarConfigs.handleNewConfig, record)
                    break
                }
                // todo: handle delete/update
                default:
            }
            break
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/socket_sagas.js